module.exports = __webpack_public_path__ + "static/3.2_ancient_mesopotamia-6a6d2cdd5b6d978af5dfc9f53ce56af9.pdf";